
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { BaseService } from '../../base.service';
import { BankListItem } from '../../models/bankListItem';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operator/map';
import { EvaluationService } from '../../services/evaluation.service';
import { EvaluationListItem } from '../../models/evaluationListItem';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormBuilder } from '@angular/forms';
import { StringifyOptions } from 'querystring';
import { Evaluation } from '../../models/evaluation';


@Component({
  selector: 'app-evaluation-detail',
  templateUrl: './evaluation-detail.component.html',
  styleUrls: [ 'evaluation-detail.component.css']
})


export class EvaluationDetailComponent implements OnInit {
  @ViewChild('templateRechazar') templateRechazar:TemplateRef<any>; 
  @ViewChild('templateAccept') templateAccept:TemplateRef<any>; 
  @ViewChild('templateError') templateError:TemplateRef<any>; 
  @ViewChild('templateSuccess') templateSuccess:TemplateRef<any>;

  constructor(
    private baseService : BaseService ,
    private evaluationService : EvaluationService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private fb: FormBuilder,

  ) { }

  titleComponent:string;
  titlePanel:string;
  evaluation:Evaluation = { 
    id: 0,
    codOperation: "", 
    userFullName: "",
    userEmail: "",
    dni: "",
    creationDate: "",
    evaluationCost: 0,
    resolutionDate: "",
    resulutionUser:  "",
    observation:  "",
    status:  "",
    resolutionUserName:"",
    resolutionUserEmail:"",
  };
    
  ngOnInit() {
    this.titleComponent = 'Evaluación';
    this.titlePanel = 'Evaluación';
    this.get();
  }
  content = "";

  credEvaluations:EvaluationListItem[] = [];
  total = 10000000;
  bigCurrentPage: number = 1;
  maxSize: number = 5;
  size: number = 4;
  page: number = 1;
  status: string = '';

  get() {
    this.evaluationService.get(+this.route.snapshot.paramMap.get('id')).subscribe( (dat) => {
      if (dat) {
        let data:any = dat;
        console.log(data);
        this.evaluation = {
          id: data.id,
          codOperation: data.codOperation, 
          userFullName: data.user.fullName,
          userEmail: data.user.email,
          dni: data.dni,
          creationDate: data.creationDate,
          evaluationCost: data.evaluationCost,
          resolutionDate: data.resolutionDate,
          resulutionUser: ( data.resolutionUser ? data.resolutionUser.email : null ),
          observation: data.observation,
          status: data.status,
          resolutionUserName: ( data.resolutionUser ? data.resolutionUser.fullName :  null),
          resolutionUserEmail: ( data.resolutionUser ? data.resolutionUser.email : null ),
        }
        this.titlePanel = 'Evaluacion : '+this.evaluation.codOperation;
      }
    });
  }
  openAprobar(){
    
    this.modalRef = this.modalService.show(this.templateAccept, {class: 'modal-sm'});
  }

  errorMsg = "";
  sustentoRechazo = "";

  openRechazar(){
    if ( !(this.sustentoRechazo > "") ){
      this.errorMsg = "Debes justificar por que rechazas esta evaluación.";
      this.modalRef = this.modalService.show(this.templateError, {class: 'modal-sm'});
    } else {
      this.modalRef = this.modalService.show(this.templateRechazar, {class: 'modal-sm'});
    }
  }

  modalRef: BsModalRef;
  
  evalCacelDecline(){
    this.modalRef.hide();
  }
  evalAccceptDecline(){
    this.modalRef.hide();
  }

  evalAccceptConfirm(){
    this.modalRef.hide();
    this.evaluationService.aprobar( this.evaluation.id , this.sustentoRechazo).subscribe(res => {
      this.modalRef = this.modalService.show(this.templateSuccess, {class: 'modal-sm'});
      console.log(res);
      this.get();
    }, err => {
      this.errorMsg = "";
      this.modalRef = this.modalService.show(this.templateError, {class: 'modal-sm'});
    });
  }
  evalCacelConfirm(){
    this.modalRef.hide();
    this.evaluationService.rechazar( this.evaluation.id , this.sustentoRechazo ).subscribe(res => {
      this.modalRef = this.modalService.show(this.templateSuccess, {class: 'modal-sm'});
      console.log(res);
      this.get();
    }, err => {
      this.errorMsg = "";
      this.modalRef = this.modalService.show(this.templateError, {class: 'modal-sm'});
    });
  }

  goBack(){
    this.router.navigate(['/dashboard/evaluations']);
  }
}






// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/evaluation/evaluation-detail.component.ts